import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PriceNegotiationEntity } from "./price-negotiation-entity";
import { VendorsEntity } from "../../../vendor-registration/entity/vendors.entity";

@Entity('job_work_creation')
export class JobworkCreationEntity {
    @PrimaryGeneratedColumn('increment', {
        name: 'job_work_id'
    })
    jobworkId: number;

    @Column('varchar', {
        name: 'division',
        nullable: false
    })
    division: string;

    @Column('int', {
        name: 'unit',
        nullable: false
    })
    unit: number;

    @Column('int', {
        name: 'sub_job_id',
        nullable: false
    })
    subJobId: number;

    @Column('varchar', {
        name: 'buyer',
        nullable: false
    })
    buyer: string;

    @Column('varchar', {
        name: 'operation_type',
        nullable: false
    })
    operationType: string;

    @Column('varchar', {
        name: 'style_no',
        nullable: false
    })
    styleNo: string;

    @Column('varchar', {
        name: 'item_no',
        nullable: false
    })
    itemNo: string;

    @Column('int', {
        name: 'addon_order_qty',
        nullable: false
    })
    addonOrderQty: number;

    @Column('int', {
        name: 'total_order_qty',
        nullable: false
    })
    totalOrderQty: number;

    @Column('date', {
        name: 'add_on_qty_date',
        nullable: false
    })
    addOnQtyDate: Date;

    @Column('int', {
        name: 'no_of_operations',
        nullable: false
    })
    noOfOperations: number;

    @Column('int', {
        name: 'rate_per_garment',
        nullable: false
    })
    ratePerGarment: number;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @OneToMany(() => PriceNegotiationEntity, (p) => p.jobworkId)
    price: PriceNegotiationEntity[]

    // @ManyToOne(() => VendorsEntity, (v) => v.jobworkId)
    // @JoinColumn({ name: 'vendor_id' })
    // vendor: VendorsEntity;

}
